var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4 8 16-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.552a976bc973cb4d5828bf26f1173529.svg";
export { ForwardRef as ReactComponent };